import { assoc, assocPath } from 'ramda';

export const SET_FNOL_VALUES = 'DRSA/FNOL/SET_FNOL_VALUES';
export const SET_FNOL_VEHICLE_DAMAGE = 'DRSA/FNOL/SET_FNOL_VEHICLE_DAMAGE';
export const SET_FNOL_THIRD_PARTY_DETAILS = 'DRSA/FNOL/SET_FNOL_THIRD_PARTY_DETAILS';
export const SET_FNOL_CIRCUMSTANCES_DETAILS = 'DRSA/FNOL/SET_FNOL_CIRCUMSTANCES_DETAILS';

export const initialState = {};

const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case SET_FNOL_VALUES:
      return { ...state, ...action.payload };
    case SET_FNOL_CIRCUMSTANCES_DETAILS:
      return assoc('customerDetails', { ...state.customerDetails, ...action.payload }, state);
    case SET_FNOL_VEHICLE_DAMAGE:
      return assocPath(['customerDetails', 'vehicleDamage'], { ...state.vehicleDamage, ...action.payload }, state);
    case SET_FNOL_THIRD_PARTY_DETAILS:
      return assoc('thirdPartyDetails', { ...state.thirdPartyDetails, ...action.payload }, state);
    default:
      return state;
  }
};

export const storeData = ({ payload }) => ({ type: SET_FNOL_VALUES, payload });

export const storeVehicleDamage = ({ payload }) => ({ type: SET_FNOL_VEHICLE_DAMAGE, payload });

export const storeThirdPartyDetails = ({ payload }) => ({ type: SET_FNOL_THIRD_PARTY_DETAILS, payload });

export const storeCircumstancesDetails = ({ payload }) => ({ type: SET_FNOL_CIRCUMSTANCES_DETAILS, payload });

const actions = {
  storeData,
  storeVehicleDamage,
  storeThirdPartyDetails,
  storeCircumstancesDetails,
};

export default { reducer, actions };
